import React from "react";
import { Table } from "antd";
import {
  fetchData,
  URL_TEMP_AGGREGATED_OBSERVATIONS_POPUP,
  URL_TEMP_OBSERVATIONS_POPUP,
  URL_STATION
} from "../../../utils/api";
import {
  TempVariablesShortName,
  TempCompletenessStatus,
  getDaysInMonth
} from "../../../utils/general";
import LinkOSCAR from "../LinkOSCAR/LinkOSCAR";
import { getWigosLabelID } from "./popupUtils";

export function getCompletenessText(props, availability) {
  let status = TempCompletenessStatus[availability];
  if (props.selectedPeriodType === "monthly") {
    if (props.stationObject.availability >= 1) {
      status = "Full";
    }
  }
  return status;
}

export function fetchTempSixHourAvailabilityPopup(
  props,
  periodsAsQP,
  linkTimeSeries,
  setContent,
  addClassToPopup
) {
  addClassToPopup();
  const promise1 = fetchData(
    `${URL_TEMP_OBSERVATIONS_POPUP}/?baseline=${props.baseline}&station=${props.stationObject.station_id}&${periodsAsQP}`
  );

  const promise2 = fetchData(
    `${URL_STATION}?network=${props.fileType}&id=${props.stationObject.station_id}`
  );

  Promise.all([promise1, promise2])
    .then(function(responses) {
      const obsData = responses[0].data;
      const stationInfo = responses[1].data;
      let labelID = getWigosLabelID(stationInfo.name, stationInfo.wigosid);
      let linkOSCAR;

      if (stationInfo.name !== "Unknown") {
        linkOSCAR = (
          <>
            <LinkOSCAR wigosid={stationInfo.wigosid} />
          </>
        );
      }
      const links = (
        <>
          {linkTimeSeries}
          <br />
          <hr />
          {linkOSCAR}
        </>
      );

      let htmlPart1 = (
        <>
          <li key={stationInfo.name}>Name: {stationInfo.name}</li>
          <li key={stationInfo.wigosid}>
            {labelID}: {stationInfo.wigosid}
          </li>
          <li key={stationInfo.elevation}>Elevation: {stationInfo.elevation}</li>
        </>
      );

      const centersAvailable = [];
      const newObsData = [];
      obsData.forEach(d => {
        if (!centersAvailable.includes(d.center)) {
          centersAvailable.push(d.center);
          newObsData.push({
            title: d.center,
            data: []
          });
        }

        const indexCenter = centersAvailable.indexOf(d.center);
        newObsData[indexCenter].data.push({
          date: d.date.slice(0, -1),
          levels: d.levels,
          var_id: TempVariablesShortName[d.var_id],
          obs_type: d.obs_type ? d.obs_type : "n/a",
          status: d.status === 0 ? "Used" : "Not used"
        });
      });

      const columns = [
        {
          title: "Date",
          dataIndex: "date",
          key: "date"
        },
        {
          title: "Layer",
          dataIndex: "levels",
          key: "levels"
        },
        {
          title: "Variable",
          dataIndex: "var_id",
          key: "var_id"
        },
        {
          title: "Obs. Type",
          dataIndex: "obs_type",
          key: "obs_type"
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status"
        }
      ];

      let htmlPart2 = newObsData.map((d, i) => {
        const title = () => d.title;
        let table;
        if (props.combinedMode) {
          table = (
            <Table
              key={i}
              rowKey={record => Math.random()}
              dataSource={d.data}
              columns={columns}
              pagination={false}
              title={title}
            />
          );
        } else {
          table = (
            <Table
              key={i}
              rowKey={record => Math.random()}
              dataSource={d.data}
              columns={columns}
              pagination={false}
            />
          );
        }
        return table;
      });
      if (newObsData.length === 0) {
        htmlPart2 = "No data";
      }

      props.onSetSelectedStation({
        name: stationInfo.name,
        wigosid: stationInfo.wigosid,
        in_oscar: props.stationObject.in_oscar,
        elevation: stationInfo.elevation
      });

      setContent(
        <>
          <ul className="popup-station-properties">{htmlPart1}</ul>
          {links}
          <br />
          <br />
          {htmlPart2}
        </>
      );
    })
    .catch(error => console.log(`Error in executing ${error}`));
}

export function fetchTempDailyOrMonthlySimplePopup(
  props,
  linkTimeSeries,
  setContent,
  expectedGBON
) {
  fetchData(
    `${URL_STATION}?network=${props.fileType}&id=${props.stationObject.station_id}`
  )
    .then(response => {
      let labelID = getWigosLabelID(response.data.name, response.data.wigosid);
      let linkOSCAR;
      if (response.data.name !== "Unknown") {
        linkOSCAR = (
          <>
            <hr />
            <LinkOSCAR wigosid={response.data.wigosid} />
          </>
        );
      }

      props.onSetSelectedStation({
        name: response.data.name,
        wigosid: response.data.wigosid,
        in_oscar: props.stationObject.in_oscar,
        elevation: response.data.elevation
      });

      let htmlPart1 = (
        <>
          <li key={1}>Name: {response.data.name}</li>
          <li key={2}>
            {labelID}: {response.data.wigosid}
          </li>
          <li key={3}>Elevation: {response.data.elevation}</li>
        </>
      );

      let baseline_expected = props.stationObject.nr_expected;
      if (
        props.baselinetxt === "2-daily" &&
        props.selectedPeriodType === "daily"
      ) {
        baseline_expected = 2;
      } else if (
        props.baselinetxt === "2-daily" &&
        props.selectedPeriodType === "monthly"
      ) {
        const nbDays = getDaysInMonth(props.selectedDate);
        baseline_expected = nbDays * 2;
      }
      let objExpected = {
        name: "#Expected",
        value: baseline_expected
      };
      if (expectedGBON) {
        objExpected = expectedGBON;
      }
      let completenessLi = "";
      if (props.stationObject.availability !== 0) {
        completenessLi = (
          <li key={1}>
            Completeness:{" "}
            {getCompletenessText(props, props.stationObject.availability)}
          </li>
        );
      }
      let htmlPart2 = (
        <ul className="popup-station-properties">
          {completenessLi}
          <li key={2}>#Received: {props.stationObject.nr_received}</li>
          <li key={3}>
            {objExpected.name}: {objExpected.value}
          </li>
          <li key={4}>
            {props.baseline !== "GBON" && props.stationObject.default_schedule
              ? "Default schedule"
              : null}
          </li>
        </ul>
      );

      const links = (
        <>
          {linkTimeSeries}
          <br />
          {linkOSCAR}
        </>
      );

      setContent(
        <>
          <ul className="popup-station-properties">{htmlPart1}</ul>

          {htmlPart2}

          {links}
        </>
      );
    })
    .catch(error => {
      console.error(
        `Couldn't fetch the data for the TEMP station with the id: ${props.stationObject.station_id} from: ${URL_STATION}`
      );
    });
}

export function fetchTempDailyOrMonthlyCombinedPopup(
  props,
  periodsAsQP,
  linkTimeSeries,
  setContent,
  expectedGBON
) {
  const promise1 = fetchData(
    `${URL_TEMP_AGGREGATED_OBSERVATIONS_POPUP}/?baseline=${props.baseline}&period_type=${props.selectedPeriodType}&report=${props.selectedReport}&station_id=${props.stationObject.station_id}&${periodsAsQP}&var_id=${props.selectedVariable}`
  );

  const promise2 = fetchData(
    `${URL_STATION}?network=${props.fileType}&id=${props.stationObject.station_id}`
  );

  Promise.all([promise1, promise2]).then(function(responses) {
    const obsData = responses[0].data;
    const stationInfo = responses[1].data;

    let labelID = getWigosLabelID(stationInfo.name, stationInfo.wigosid);
    let linkOSCAR;
    if (stationInfo.name !== "Unknown") {
      linkOSCAR = (
        <>
          <hr />
          <LinkOSCAR wigosid={stationInfo.wigosid} />
        </>
      );
    }

    props.onSetSelectedStation({
      name: stationInfo.name,
      wigosid: stationInfo.wigosid,
      in_oscar: props.stationObject.in_oscar,
      elevation: stationInfo.elevation
    });

    let htmlPart1 = (
      <>
        <li key={1}>Name: {stationInfo.name}</li>
        <li key={2}>
          {labelID}: {stationInfo.wigosid}
        </li>
        <li key={3}>Elevation: {stationInfo.elevation}</li>
      </>
    );

    let baseline_expected = props.stationObject.nr_expected;
    if (
      props.baselinetxt === "2-daily" &&
      props.selectedPeriodType === "daily"
    ) {
      baseline_expected = 2;
    } else if (
      props.baselinetxt === "2-daily" &&
      props.selectedPeriodType === "monthly"
    ) {
      const nbDays = getDaysInMonth(props.selectedDate);
      baseline_expected = nbDays * 2;
    }
    let objExpected = {
      name: "#Expected",
      value: baseline_expected
    };
    if (expectedGBON) {
      objExpected = expectedGBON;
    }

    let htmlPart2 = "";
    let htmlExpectedMonthly = "";
    let htmlNoteMonthly = "";
    if (props.selectedPeriodType === "monthly") {
      htmlExpectedMonthly = (
        <div>
          {objExpected.name}: {objExpected.value}
        </div>
      );
    } else {
      htmlPart2 = (
        <ul className="popup-station-properties">
          <li key={3}>
            {objExpected.name}: {objExpected.value}
          </li>
          <li key={4}>
            {props.baseline !== "GBON" && props.stationObject.default_schedule
              ? "Default schedule"
              : null}
          </li>
        </ul>
      );
    }

    let centers = [];
    let centersValues = [];
    let maxIndex = 0;
    let max = 0;
    for (let i = 0; i < obsData.length; i++) {
      const element = obsData[i];
      let max_nr_expected = 0;
      if (max_nr_expected < element.nr_expected) {
        max_nr_expected = element.nr_expected;
      }
      if (!centers.includes(element.center)) {
        centers.push(element.center);
        centersValues.push({
          type: "title",
          value: element.center
        });
      }
      if (props.selectedPeriodType === "monthly") {
        if (element.nr_received > max) {
          max = element.nr_received;
          maxIndex = i;
        }
        centersValues.push({
          type: "value",
          value: `#Received: ${element.nr_received}`
        });
      } else {
        centersValues.push({
          type: "value",
          value: `#Received: ${element.nr_received}`
        });
      }

      if (
        (props.baseline === "GBON" && element.availability === 3) ||
        (props.baseline === "OSCAR" && element.availability !== 0)
      ) {
        centersValues.push({
          type: "value",
          value: `Completeness: ${getCompletenessText(
            props,
            element.availability
          )}`
        });
      }
    }
    const htmlPart3 = centersValues.map((k, i) => {
      let value = k.value;
      if (
        props.selectedPeriodType === "monthly" &&
        props.selectedReport === "availability" &&
        k.value.includes("#Received")
      ) {
        if (i === maxIndex + 1 || i === maxIndex * 3 + 1) {
          value = <b> {k.value} </b>;
        }
      }
      let classElement;
      if (k.type === "title") {
        classElement = "popup-title-center";
      }
      return (
        <li key={i} className={classElement}>
          {value}
        </li>
      );
    });

    const links = (
      <>
        {linkTimeSeries}
        <br />
        {linkOSCAR}
      </>
    );
    setContent(
      <>
        <ul className="popup-station-properties">{htmlPart1}</ul>
        {htmlExpectedMonthly}

        {htmlPart2}
        <ul className="popup-station-properties">{htmlPart3}</ul>
        {htmlNoteMonthly}
        {links}
      </>
    );
  });
}

export function fetchTempQualityPopup(
  props,
  periodsAsQP,
  multiplier,
  linkTimeSeries,
  setContent
) {
  fetchData(
    `${URL_TEMP_AGGREGATED_OBSERVATIONS_POPUP}/?baseline=${props.baseline}&period_type=${props.selectedPeriodType}&report=${props.selectedReport}&station_id=${props.stationObject.station_id}&${periodsAsQP}&var_id=${props.selectedVariable}`
  ).then(response => {
    let labelID = getWigosLabelID(
      response.data[0].station,
      response.data[0].wigosid
    );

    props.onSetSelectedStation({
      name: response.data[0].station,
      wigosid: response.data[0].wigosid,
      in_oscar: response.data[0].in_oscar,
      elevation: response.data[0].elevation
    });

    const part1 = [
      `Name: ${response.data[0].station}`,
      `${labelID}: ${response.data[0].wigosid}`,
      `Elevation: ${response.data[0].elevation}`
    ];

    let centers = [];
    let centersValues = [];
    for (let i = 0; i < response.data.length; i++) {
      const element = response.data[i];
      if (!centers.includes(element.center)) {
        centers.push(element.center);
        centersValues.push({
          type: "title",
          value: element.center
        });
      }

      const toHighligth =
        Math.round(element.rms * 100000) / 100000 ===
        Math.round(props.stationObject.rms * 100000) / 100000;

      const value = element.rms
        ? Math.round(element.rms * multiplier * 1000) / 1000
        : "Not available";
      centersValues.push({
        type: "value",
        value: `${element.levels}: ${value}`,
        highlight: toHighligth
      });
    }

    const htmlPart1 = part1.map(v => {
      return <li key={v}>{v}</li>;
    });

    const htmlPart2 = centersValues.map(k => {
      let classElement;
      if (k.type === "title") {
        classElement = "popup-title-center";
      }
      if (k.highlight) {
        classElement = "popup-value-highlighted";
      }
      return (
        <li key={k.value} className={classElement}>
          {k.value}
        </li>
      );
    });

    const htmlContent = (
      <>
        {htmlPart1}
        {htmlPart2}
      </>
    );

    let linkOSCAR;

    let links = linkTimeSeries;

    if (response.data[0].station !== "Unknown") {
      linkOSCAR = (
        <>
          <LinkOSCAR wigosid={response.data[0].wigosid} />
        </>
      );
      links = (
        <>
          {linkTimeSeries}
          <br />
          <hr />
          {linkOSCAR}
        </>
      );
    }

    setContent(
      <ul className="popup-station-properties">
        {htmlContent}
        {links}
      </ul>
    );
  });
}
